import React from "react"
import ValidateDocuments from "./validate-documents"

const ValidateDocumentsWithoutKyc = () => <ValidateDocuments kyc={false} />

export default ValidateDocumentsWithoutKyc
